import React, { useEffect } from "react";

const AppCustomerConsent: React.FC = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const requestId = params.get("request_id");

    if (requestId) {
      window.location.href = `moneymaxcustomer://app-customer-consent?request_id=${requestId}`;
    }
  }, []);

  return <>Redirecting customer pledge consent to the app...</>;
};

export default AppCustomerConsent;
